import type { FirebaseOptions } from 'firebase/app'
import { IS_DEV_ENV } from '@/core/constants'

const env = import.meta.env

const devConfig: FirebaseOptions = {
  apiKey: env.VITE_DEV_FIREBASE_API_KEY,
  authDomain: env.VITE_DEV_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_DEV_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_DEV_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_DEV_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_DEV_FIREBASE_APP_ID,
}

const productionConfig: FirebaseOptions = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
}

export const firebaseConfig: FirebaseOptions = IS_DEV_ENV ? devConfig : productionConfig
